import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { injectTranslation, useTitle } from '@sona/angular-util-common';
import { HlmButtonDirective } from '@spartan-ng/ui-button-helm';

@Component({
    selector: 'sona-not-found-page',
    imports: [
        NgOptimizedImage,
        RouterLink,
        TranslateModule,
        HlmButtonDirective
    ],
    template: `
    <img
        class="tw-mb-8"
        ngSrc="assets/images/dizzy-face-emoji.png"
        alt=""
        width="180"
        height="180"
        priority
    />
    <h1 class="tw-text-3xl tw-font-bold">{{ 'PAGE.NOT_FOUND.TITLE' | translate }}</h1>
    <p class="tw-text-muted-foreground tw-text-lg">{{ 'PAGE.NOT_FOUND.MESSAGE' | translate }}</p>
    <button hlmBtn routerLink="/">{{ 'PAGE.NOT_FOUND.ACTION.TO_HOME' | translate }}</button>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-gap-2 tw-p-12 dot-pattern'
    }
})
export class NotFoundPage {
    constructor() {
        useTitle(injectTranslation('PAGE.NOT_FOUND.TITLE'));
    }
}
